/**
 * Shared SEO title helper — keeps page titles within Google's display budget.
 *
 * Google truncates titles beyond ~600px, which corresponds to roughly 65
 * characters for typical body text. Titles that spill over lose the brand
 * suffix and keyword context in SERPs.
 *
 * Usage:
 *   buildSeoTitle("Metformin 500mg Tablet Wholesale")
 *   // → "Metformin 500mg Tablet Wholesale | Premier Pharma"  (49 chars)
 *
 *   buildSeoTitle("Hydrochlorothiazide Bisoprolol Fumarate 10/6.25mg Tablet Wholesale")
 *   // → "Hydrochlorothiazide Bisoprolol Fumarate 10/6.25… | Premier Pharma"  (65 chars)
 */

const SUFFIX = " | Premier Pharma";
const MAX_TITLE = 65;
const MAX_BASE = MAX_TITLE - SUFFIX.length; // 47

/**
 * Build an SEO title that is guaranteed to be ≤ 65 characters.
 *
 * @param base   The descriptive portion of the title (no brand suffix).
 * @param suffix Override the brand suffix (default " | Premier Pharma").
 */
export function buildSeoTitle(base: string, suffix = SUFFIX): string {
  const maxBase = MAX_TITLE - suffix.length;
  if (base.length <= maxBase) {
    return `${base}${suffix}`;
  }
  // Truncate to maxBase - 1 to make room for the ellipsis character
  return `${base.slice(0, maxBase - 1).trimEnd()}…${suffix}`;
}
